import React from 'react';
import styled from '@emotion/styled';

import Button from '../../../components/Button';

interface RetryPaymentButtonProps {
  subscription: Subscription;
  subscriptionIsInDunning: boolean;
  isLoadingOrderNow: boolean;
  orderSubmitted: boolean;
  onOrderNowConfirm: (isConfirmed: boolean) => void;
  t: (key: string) => string;
}

const RetryPaymentButton = ({
  subscription,
  subscriptionIsInDunning,
  onOrderNowConfirm,
  isLoadingOrderNow,
  orderSubmitted,
  t,
}: RetryPaymentButtonProps): React.ReactElement | null => {
  const isFailed = subscription?.SubscriptionStatus === 'FAILED';
  const isRetryingManually = subscription?.RetryingManually;
  const isInBillingProcess =
    subscription?.IsBilling || subscription?.IsBillingScheduled;

  return subscriptionIsInDunning || isFailed ? (
    <CustomButton
      _className="bundle-button--retry-payment"
      disabled={
        orderSubmitted ||
        isRetryingManually ||
        isLoadingOrderNow ||
        isInBillingProcess
      }
      outlined
      filled
      onClick={() => onOrderNowConfirm(true)}
    >
      {orderSubmitted
        ? t('subscription.order_submitted')
        : t('subscription.retry_payment')}
    </CustomButton>
  ) : null;
};

const CustomButton = styled(Button)`
  height: 44px;
  display: flex;
  height: auto;
  justify-content: center;
  align-items: center;
  padding: 8px;
`;

export default RetryPaymentButton;
